import { assert_string_not_empty, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__generation_price_get extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_PRICE_GET;

  /*
   * STATIC METHODS
   */

  static get_unique_requests(requests: DTO_REQUEST__generation_price_get[]): DTO_REQUEST__generation_price_get[] {
    let out_map = new Map<string, DTO_REQUEST__generation_price_get>();

    for (let request of requests) {
      out_map.set(request.hash, request);
    }

    return Array.from(out_map.values());
  }
  /*
   * INSTANCE FIELDS
   */

  generation_settings!: 'DTO__generation_settings_sd_1';
  hash!: string;

  workspace_id!: string;
  ml_asset_reservation_id!: string;

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  assert_standard_fields(): void {
    assert_string_not_empty(this.hash);

    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.ml_asset_reservation_id);
  }
}
